import { useMemo } from 'react'

import { FormArtwork } from './FormArtwork'
import { useArtworksContext } from './FormArtworksContext'

import type { ReactElement } from 'react'

export function FormArtworksList(): ReactElement {
  const { data } = useArtworksContext()

  const artworks = useMemo(
    () =>
      [...data].map(([id, artwork]) => ({
        ...artwork,
        id,
      })),
    [data],
  )

  return (
    <>
      {artworks.map((artwork, idx) => (
        <FormArtwork
          key={artwork.id}
          idx={idx + 1}
          close={() => null}
          {...artwork}
        />
      ))}
    </>
  )
}
